import React, { useEffect, useState } from "react";
import { Col, Form, Row, Dropdown } from "react-bootstrap";
import { showOnlySections } from "../Data/options";
import ChartTypeSelector from "./ChartTypeSelector";
import CustomMetricChart from "./CustomMetricChart";
import ShowOnlyDropdown from "./ShowOnlyDropdown";
import metricIcon from "../../../Common/Assets/Images/metrics-portfolio.png";
import _ from "lodash";
import { DropDownList } from "../../Reports/common-components/dropdown-list";
import { MultiSelectSearchCustomCheck } from "../../../Common/Components/MultiSelectSearchCustomCheck";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";

const CustomMetricRightPanel = ({
    selectedMetric,
    defaultChartType = "number",
    setCardData,
    setOriginalValues,
    metricItem
}) => {
    const [chartType, setChartType] = useState<any>(null);
    const [cardId, setCardId] = useState<any>(null);
    const [chartTitle, setChartTitle] = useState("Untitled");
    const [chartComparison, setChartComparison] = useState<any>([]);
    const [chartComparisonList, setChartComparisonList] = useState<any>([]);
    const [cardTypeList, setCardTypeList] = useState<any>([]);
    const [showOnly, setShowOnly] = useState<any>(null);
    const [error, setError] = useState("");
    const [comparionError, setComparionError] = useState("");
    const [inputPosition, setInputPosition] = useState(0);
    const [groupingValue, setGroupingValue] = useState<any>(null);

    const handleBlur = (inputPos) => {
        if (inputPos == 1) {
            setChartTitle((prev) => prev.trim());
            if (chartTitle.trim() === "") {
                setError("Chart Title is required.");
            } else {
                setError("");
            }
        }
        else {

            if (chartComparison.length == 0) {
                setComparionError("Comparison is required.");
            } else {
                setComparionError("");
            }
        }

        setInputPosition(inputPos)
    };

    useEffect(() => {
        if (metricItem && selectedMetric && selectedMetric.isEdit) {
            const DynamicCardType = selectedMetric?.map(
                (item) => ({
                    ...item,
                    name: item.cardName.toLowerCase(),
                    value: item.cardName.toLowerCase(),
                    icon: item.cardName,
                })
            );

            if (metricItem?.showOnly) {
                const flattenedItems = showOnlySections.flatMap(section => section.items);
                const _showOnly = flattenedItems.find(item => item.value === metricItem.showOnly);
                setShowOnly(_showOnly)
            }
            else {
                setShowOnly(null)
            }

            setCardTypeList(DynamicCardType);
            // setChartTitle(metricItem.title);

            const selectedCardType = selectedMetric?.find(item => item.cardId === metricItem.cardId);

            if (selectedCardType) {
                setChartType(selectedCardType?.cardName?.toLowerCase());
                setTimeout(() => {
                    setCardId(selectedCardType?.cardId);
                }, 0)
            }
        }
    }, [selectedMetric, metricItem])

    useEffect(() => {
        if (metricItem && selectedMetric && selectedMetric.isEdit && cardId) {
            const selectedComparisons = metricItem.dashboardComparisonWidgetMappingResponse?.map(item => item?.comparisonId)
            setChartComparison([])
            const DynamicComparisonList = _.uniqBy(
                selectedMetric?.find(item => item.cardId === cardId)?.paramComparisonMappingResponse?.map((item) => ({
                    id: item.comparisonId,
                    description: item.comparisonName,
                    value: item.comparisonName,
                    label: item.comparisonName,
                    isChecked: selectedComparisons?.includes(item.comparisonId),
                })) || [],
                "value"
            );

            const _chartComparison = DynamicComparisonList?.filter(item => item?.isChecked)
            setChartComparison(_chartComparison)
            setChartComparisonList(DynamicComparisonList);

            setOriginalValues({
                cardId: metricItem.cardId,
                chartType: metricItem.cardType.toLowerCase(),
                chartTitle: metricItem.title || "",
                chartComparison: _chartComparison.length > 0 ? _chartComparison : [],
                showOnly: showOnly,
                groupingValue: groupingValue
            })
        }
    }, [selectedMetric, cardId, metricItem, groupingValue]);

    useEffect(() => {
        if (selectedMetric && !selectedMetric.isEdit) {
            const DynamicCardType = selectedMetric?.map(
                (item) => ({
                    ...item,
                    name: item.cardName.toLowerCase(),
                    value: item.cardName.toLowerCase(),
                    icon: item.cardName,
                })
            );

            setShowOnly(null)
            setCardTypeList(DynamicCardType);
            // setChartTitle(selectedMetric.paramDisplayName);

            const selectedCardType = selectedMetric?.find(item => item.isDefault === 1);

            if (selectedCardType) {
                setChartType(selectedCardType?.cardName?.toLowerCase());
                setCardId(selectedCardType?.cardId);
            }
        }
    }, [selectedMetric]);

    useEffect(() => {
        if (selectedMetric && !selectedMetric.isEdit && cardId) {
            setChartComparison([]);
            const DynamicComparisonList = _.uniqBy(
                selectedMetric?.find(item => item.cardId === cardId)?.paramComparisonMappingResponse?.map((item) => ({
                    id: item.comparisonId,
                    description: item.comparisonName,
                    value: item.comparisonName,
                    label: item.comparisonName,
                    isChecked: false,
                })) || [],
                "value"
            );

            setChartComparisonList(DynamicComparisonList);
        }
    }, [selectedMetric, cardId]);

    useEffect(() => {
        setCardData((prev) => ({
            ...prev,
            cardId,
            chartType,
            chartTitle,
            chartComparison,
            showOnly,
            groupingValue
        }));
    }, [chartType, chartTitle, chartComparison, showOnly, groupingValue]);

    const handleChartType = (item) => {
        setChartType(item.value);
        setCardId(item.cardId); //  check here debug
        // setChartTitle(selectedMetric?.paramDisplayName);
        setChartComparison([]);
        setGroupingValue(null);
        setShowOnly(null);
        setInputPosition(1)
        setComparionError("")
        setError("")
        setChartComparisonList((prev) =>
            prev.map((prevItem) => ({
                ...prevItem,
                isChecked: false,
            }))
        );
    };

    return (
        <div style={{ flex: 1 }}>
            {selectedMetric ? (
                <Row className="ff chart-row-wrapper" style={{ justifyContent: "space-evenly" }}>
                    <Col md={4} className="chart-selector-btn">
                        {cardTypeList?.length > 0 && (
                            <ChartTypeSelector
                                chartOptions={cardTypeList}
                                chartType={chartType}
                                handleChartType={handleChartType}
                            />
                        )}
                        <Form.Group
                            controlId="chartTitle"
                            className={`mb-3 ${error && inputPosition >= 1 ? "error" : ""}`}
                        >
                            <Form.Label className="field-title">Chart Title <span>*</span></Form.Label>
                            <Form.Control
                                value={chartTitle}
                                onChange={(e) => {
                                    setChartTitle(e.target.value.replace(/^\s+/, ""));
                                    setError("");
                                }}
                                type="text"
                                placeholder="Enter Chart Title"
                                defaultValue={selectedMetric?.paramDisplayName}
                                onBlur={() => handleBlur(1)}
                                maxLength={50}
                                className={error ? "error-invalid" : ""}
                            />
                            {error && inputPosition >= 1 && <div className="error-message">{error}</div>}
                        </Form.Group>

                        {(chartType === "bar" || chartType === "line") &&
                            selectedMetric?.length > 0 &&
                            selectedMetric.find(item => item.cardId === cardId)?.dashboardDataGroupingResponse?.length > 0 && (
                                <Form.Group controlId="groupBy" className="mb-3">
                                    <Form.Label className="field-title">
                                        {chartType === "bar" ? "X-Axis" : "Group By"}
                                    </Form.Label>
                                    <Dropdown
                                        onSelect={(eventKey) => {
                                            const selectedCard = selectedMetric.find(item => item.cardId === cardId);
                                            const selected = selectedCard?.dashboardDataGroupingResponse?.find(
                                                (item) => String(item.id) === eventKey
                                            );
                                            setGroupingValue(selected);
                                        }}
                                    >
                                        <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                                            {groupingValue?.name || "Select"}
                                        </Dropdown.Toggle>

                                        {/* <Dropdown.Menu>
                                            {selectedMetric.find(item => item.cardId === cardId)?.dashboardDataGroupingResponse?.map((item) => (
                                                <Dropdown.Item key={item.id} eventKey={item.id}>
                                                    {item.description}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu> */}
                                    <Dropdown.Menu>
                                        {selectedMetric.find(item => item.cardId === cardId)?.dashboardDataGroupingResponse?.map((item, index, arr) => (
                                            <React.Fragment key={item.id}>
                                                <Dropdown.Item eventKey={item.id}>
                                                    <div>
                                                        <div style={{ fontWeight: 500 }}>{item.name}</div>
                                                        {/* <p style={{ fontSize: "0.85rem", color: "#6c757d" }}> */}
                                                        <p>
                                                        {item.description}
                                                        </p>
                                                    </div>
                                                </Dropdown.Item>
                                                {index < arr.length - 1 && <hr />}
                                            </React.Fragment>
                                        ))}
                                    </Dropdown.Menu>
                                    </Dropdown>
                                </Form.Group>
                            )}

                        {chartType &&
                            chartType !== "progress" &&
                            chartComparisonList?.length > 0 && (
                                <Form.Group
                                    key={`${selectedMetric.paramDisplayName}-${chartType}-comparison`}
                                    controlId="comparison"
                                    className="mb-3"
                                >
                                    <Form.Label className="field-title">Comparison</Form.Label>

                                    <MultiSelectSearchCustomCheck
                                        isSearch={false}
                                        hidofgroup={[]}
                                        // itemList={DynamicComparisonList}
                                        itemList={chartComparisonList}
                                        updateMultiSelectItem={(item: any) => {
                                            if (!item) {
                                                return;
                                            }
                                            setChartComparison(item);
                                        }}
                                        dataChange={() => { }}
                                        isSelectAll={true}
                                        placeholder={"Select Comparison"}
                                        filtertitle={"Select Comparison"}
                                    />
                                </Form.Group>
                            )}                        
                        <div>
                            <Form.Label className="field-title">Description</Form.Label>
                            {/* <p>{selectedMetric.paramDescrp || ""}</p> */}
                            {chartType === "line" ?
                                <p>This card will show the aggregate or sum over time by the breakdown and data you've selected.</p> :
                                chartType === "bar" ?
                                    <p>This card will show the aggregate or sum displayed in bars by the breakdown and data you've selected.</p> :
                                    <p>This card will show the sum or aggregate of the data you selected.</p>
                            }
                        </div>
                    </Col>

                    {chartType && (
                        <Col
                            md={6}
                            className="chart-column"
                            style={{ alignSelf: "center" }}
                        >
                            <CustomMetricChart
                                isDummyData
                                chartType={chartType}
                                chartTitle={chartTitle}
                                chartComparison={chartComparison}
                                showOnly={showOnly?.item || 5}
                                metric={selectedMetric}
                                xLabel={groupingValue?.name}
                            />
                        </Col>
                    )}
                </Row>
            ) : (
                <div className="default-view">
                    <h5 className="sub-heading">Select a metric to start</h5>
                    <img
                        className="img-fluid"
                        src={metricIcon}
                        alt="Select a metric to start"
                    />
                </div>
            )}
        </div>
    );
};

export default CustomMetricRightPanel;